<template>
  <div class="studentifno-addstudent-form">
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" style="max-height: 500px; overflow-y: auto;">
      <el-form-item label="姓名" label-width="100px" prop="studentName">
        <el-input v-model="ruleForm.studentName" autocomplete="off" placeholder="请输入姓名"></el-input>
      </el-form-item>
      <el-form-item label-width="100px" label="性别" required>
        <el-radio-group v-model="ruleForm.sex">
          <el-radio label="男"></el-radio>
          <el-radio label="女"></el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="学号" label-width="100px" prop="studentNumber">
        <el-input v-model="ruleForm.studentNumber" autocomplete="off" placeholder="请输入学号"></el-input>
      </el-form-item>
      <el-form-item label="班级职务" label-width="100px" prop="duty">
        <el-input v-model="ruleForm.duty" autocomplete="off" placeholder="请输入班级职务"></el-input>
      </el-form-item>
      <el-form-item label="政治面貌" label-width="100px" prop="politicsStatus">
        <el-input v-model="ruleForm.politicsStatus" autocomplete="off" placeholder="请输入政治面貌"></el-input>
      </el-form-item>
      <el-form-item label="身份证" label-width="100px" prop="idCard">
        <el-input v-model="ruleForm.idCard" autocomplete="off" placeholder="请输入身份证"></el-input>
      </el-form-item>
      <el-form-item label="学生状态" label-width="100px" prop="status">
        <el-select v-model="ruleForm.status" placeholder="请选择">
          <el-option v-for="item in studentTypeList" :key="item.dictValue" :label="item.dictLabel"
            :value="item.dictValue">
          </el-option>
        </el-select>
      </el-form-item>
      <!-- <el-form-item label="选择班级:" prop="classNameVal" label-width="100px">
        <el-cascader
          v-model="ruleForm.classNameVal"
          placeholder="请选择班级"
          :props="classProps"
          :options="classSelect"
        ></el-cascader>
      </el-form-item> -->
      <el-form-item label="选择年级" label-width="100px" prop="gradeId">
        <el-select v-model="ruleForm.gradeId" placeholder="选择年级" @change="selectGrade" clearable>
          <el-option v-for="item in gradeSelectList" :key="item.gradeId" :label="item.gradeName" :value="item.gradeId">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="选择班级" label-width="100px" prop="classId">
        <el-select v-model="ruleForm.classId" placeholder="选择班级" @change="selectClass" clearable>
          <el-option v-for="item in classSelectList" :key="item.classId" :label="item.className" :value="item.classId">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="家庭地址" label-width="100px" prop="address">
        <el-input v-model="ruleForm.address" autocomplete="off" placeholder="请输入家庭地址"></el-input>
      </el-form-item>
      <el-form-item label="出生年月日" label-width="100px" prop="birthday">
        <el-date-picker v-model="ruleForm.birthday" type="date" value-format="yyyy-MM-dd" placeholder="选择出生年月日">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="过敏源" label-width="100px" prop="allergen">
        <el-input v-model="ruleForm.allergen" autocomplete="off" :placeholder="placeholder"></el-input>
      </el-form-item>
      <el-form-item label="病史" label-width="100px" prop="medicalHistory">
        <el-input v-model="ruleForm.medicalHistory" autocomplete="off" :placeholder="placeholder"></el-input>
      </el-form-item>
      <el-form-item label="民族" label-width="100px" prop="nation">
        <el-input v-model="ruleForm.nation" autocomplete="off" :placeholder="placeholder"></el-input>
      </el-form-item>
      <el-form-item label="籍贯" label-width="100px" prop="nativePlace">
        <el-input v-model="ruleForm.nativePlace" autocomplete="off" :placeholder="placeholder"></el-input>
      </el-form-item>
      <el-form-item label="毕业小学" label-width="100px" prop="primarySchool">
        <el-input v-model="ruleForm.primarySchool" autocomplete="off" :placeholder="placeholder"></el-input>
      </el-form-item>
      <el-form-item label="学生电话" label-width="100px" prop="studentPhone">
        <el-input v-model="ruleForm.studentPhone" autocomplete="off" :placeholder="placeholder"></el-input>
      </el-form-item>
      <el-form-item label="家长电话" label-width="100px" prop="patriarchPhone">
        <el-input v-model="ruleForm.patriarchPhone" autocomplete="off" :placeholder="placeholder"></el-input>
      </el-form-item>
    </el-form>
    <div class="form-btn">
      <!-- <el-button @click="dialogClose">取 消</el-button> -->
      <el-button type="primary" @click="confirm">确 定</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  props: ["classSelect", "classProps", "studentTypeList", "gradeSelectList",],
  data() {
    return {
      ruleForm: {
        studentName: "",
        studentNumber: "",
        address: "",
        duty: "",
        politicsStatus: "",
        classNameVal: "",
        status: "",
        sex: "男",
        nation: "",
        birthday: "",
        allergen: "",
        medicalHistory: "",
        nativePlace: "",
        primarySchool: "",
        studentPhone: "",
        patriarchPhone: "",
        classId: "",
        gradeId: "",
        className: "",
        gradeName: "",
        idCard: ""
      },
      classSelectList: [],
      rules: {
        studentName: [
          { required: true, message: "请输入学生姓名", trigger: "blur" },
        ],
        // duty: [{ required: true, message: "请输入学生职务", trigger: "blur" }],
        // politicsStatus: [{ required: true, message: "请输入政治面貌", trigger: "blur" }],
        studentNumber: [
          { required: true, message: "请输入学生学号", trigger: "change" },
        ],
        classId: [
          { required: false, message: "请选择班级", trigger: "change" },
        ],
        gradeId: [
          { required: true, message: "请选择年级", trigger: "change" },
        ],
        status: [{ required: true, message: "请选择状态", trigger: "change" }],
      },
      placeholder: '请输入'
    };
  },
  methods: {
    // 切换年级
    selectGrade(e) {
      // console.log(e);
      this.ruleForm.gradeId = e;
      this.ruleForm.classId = "";
      this.ruleForm.className = "";
      this.ruleForm.gradeName = this.gradeSelectList.find(item => item.gradeId == e).gradeName;
      if (e !== "") {
        this.classSelectList = this.gradeSelectList.find(
          (item) => item.gradeId == e
        ).schoolClassList;
      } else {
        this.gradePlaceholder = "请选择年级";
        this.classSelectList = [];
      }
    },
    selectClass(e) {
      this.ruleForm.classId = e;
      if (e != '') {
        this.ruleForm.className = this.classSelectList.find(item => item.classId == e).className;
      } else {
        this.ruleForm.className = '';
      };
    },
    confirm() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.$emit("formSubmit", this.ruleForm);
        } else {
          return false;
        }
      });
    },
    reset() {
      this.ruleForm = {
        studentName: "",
        studentNumber: "",
        address: "",
        duty: "",
        politicsStatus: "",
        classNameVal: "",
        status: "",
        sex: "男",
        nation: "",
        birthday: "",
        allergen: "",
        medicalHistory: "",
        nativePlace: "",
        primarySchool: "",
        studentPhone: "",
        patriarchPhone: "",
        classId: "",
        gradeId: "",
        className: "",
        gradeName: "",
        idCard: ""
      };
      this.$refs["ruleForm"].clearValidate(); //移除表单检验结果
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./studentifno-addstudent-form.scss";
</style>
